var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16.5 19.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    "data-name": "Group 2610"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.75 8.25a2.5 2.5 0 1 0-2.5 2.5 2.5 2.5 0 0 0 2.5-2.5",
    "data-name": "Path 18601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.75c-1.2 0-7.5-5.1-7.5-10.437a7.5 7.5 0 1 1 15 0c0 5.337-6.3 10.437-7.5 10.437",
    "data-name": "Path 18602"
  }))));
};
export default SvgLocation;